var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-theme"},[_c('div',{staticClass:"content-theme-l"},[_vm._t("content-theme-l")],2),_c('div',{staticClass:"content-theme-r"},[_vm._t("content-title-r")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }